import { Media } from 'enums';
import styled from 'styled-components';

type LabelStyledProps = {
  isOnDiscountPage?: boolean;
  isExpired?: boolean;
  isCheckRelevance?: boolean;
  isNew?: boolean;
};

export const LabelMobileStyle = styled.div<LabelStyledProps>`
  min-width: 79px;
  height: 30px;
  background: ${({ theme, isExpired, isCheckRelevance }) =>
    isExpired || isCheckRelevance
      ? theme.colors.red1
      : theme.colors.label_color};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  z-index: 1;
  justify-content: center;
  align-items: center;
  padding: 7px 14px;
  box-sizing: border-box;
  position: ${({ isOnDiscountPage }) =>
    isOnDiscountPage ? 'static' : 'absolute'};
  top: 14px;
  left: 14px;
  margin-right: 3px;

  @media ${Media.notebook} {
    min-width: 92px;
    height: 40px;
    top: 20px;
    left: 20px;
    padding: 11px 16px;
  }
`;
